import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {InlineUserDashboardSection} from "../components/InlineUserDashboardSection";
import {InlineUserDashboardTab, InlineUserDashboardTabStyle} from "./InlineUserDashboardTab";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {Messages} from "../../../../Messages";
import {userService} from "../../../../../client/connection/Services";
import {CheckboxInput} from "../../../../../core/ui/input/CheckboxInput.jsx";
import {
    apiUserUpdateNewsletterSubscriptions,
    MerchantAudienceMemberStore, NewsletterSubscriptionUpdateType
} from "../../../../../client/state/merchant/MerchantAudienceMemberStore";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {LoadingSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {MerchantUserStore} from "../../../../../client/state/merchant/MerchantUserStore";
import {MerchantAudienceStore} from "../../../../../client/state/merchant/MerchantAudienceStore";
import {Toast} from "../../../../ui/Toast.jsx";


class InlineUserDashboardNewslettersTabStyle extends InlineUserDashboardTabStyle {
    @styleRule
    checkboxesList = {
        padding: "16px 0",
    };

    @styleRule
    separatorLine = {
        width: "100%",
        height: 0.5,
        background: "#E5E5E5",
    };

    @styleRule
    message = {
        marginTop: 16,
    };
}

@registerStyle(InlineUserDashboardNewslettersTabStyle)
export class InlineUserDashboardNewslettersTab extends InlineUserDashboardTab {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.newslettersTitle,
        }
    }

    refreshNewsletters() {
        this.checkedNewsletters = MerchantAudienceStore.all().filter(audience =>
            MerchantAudienceMemberStore.find(member => member.isSubscribed() && member.audience === audience))
    }

    async update() {
        const emailAddress = userService.getUserEmail();
        const {merchantId} = iFrameMerchantService;
        const merchantUser = MerchantUserStore.getByUserAndMerchant(userService.getUserId(), merchantId);
        const canReceivePromotionalEmails = this.promotionalEmailsCheckbox.getValue();
        const updatedCanReceivePromotionalEmails = !merchantUser || canReceivePromotionalEmails !== merchantUser.canReceivePromotionalEmails;
        LoadingSpinner.show();
        try {
            await apiUserUpdateNewsletterSubscriptions({
                emailAddress,
                merchantId,
                updateType: NewsletterSubscriptionUpdateType.REPLACE,
                newsletterIds: this.checkedNewsletters.map(newsletter => newsletter.id),
                ...(updatedCanReceivePromotionalEmails ? {canReceivePromotionalEmails} : {}),
            });
            Toast.showSuccess(Messages.changesSaved);
        } catch (error) {
            Toast.showError(error);
        } finally {
            LoadingSpinner.hide();
        }
    }

    async updateNewsletterForSubscribe(audience, include) {
        if (include) {
            this.checkedNewsletters.push(audience);
        } else {
            this.checkedNewsletters.splice(this.checkedNewsletters.indexOf(audience), 1);
        }
        await this.update();
    }

    render() {
        const {styleSheet} = this;
        const newsletters = MerchantAudienceStore.all();
        const merchantName = iFrameMerchantService.getMerchant().name;
        const merchantUser = MerchantUserStore.getByUserAndMerchant(userService.getUserId(), iFrameMerchantService.merchantId);

        if (!this.checkedNewsletters) {
            this.refreshNewsletters();
        }

        return <InlineUserDashboardSection
                    titleMessage={<MessageElement message={Messages.signUpForMerchantNewsletter} args={merchantName}/>}>
            <MessageElement message={Messages.newslettersEditDescription(userService.getUserEmail())}/>
            <div className={styleSheet.checkboxesList}>
                {newsletters.map(audience => <CheckboxInput label={audience.name}
                                                              onChange={enabled => this.updateNewsletterForSubscribe(audience, enabled)}
                                                              initialValue={this.checkedNewsletters.indexOf(audience) !== -1}
                                                              className={styleSheet.textSection}/>)}
                <div className={styleSheet.separatorLine}/>
                <CheckboxInput ref="promotionalEmailsCheckbox"
                                 className={styleSheet.textSection} onChange={() => this.update()}
                                 label={Messages.allowPromotionalEmailsFromMerchant(merchantName)}
                                 initialValue={!merchantUser || merchantUser.canReceivePromotionalEmails}/>
            </div>
            <MessageElement message={Messages.newsletterDashboardEmailDescription(userService.getUserEmail())}
                            className={styleSheet.message}/>
        </InlineUserDashboardSection>
    }

    onMount() {
        super.onMount();
        this.attachChangeListener(MerchantAudienceMemberStore, () => {
            this.refreshNewsletters();
            this.redraw();
        })
    }
}
